module.exports = __webpack_public_path__ + "static/media/newtab.f974afe0.svg";